import Clickable from 'components/Common/Clickable'
import LoyaltyPill from 'components/Luxkit/LoyaltyTierPill'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { rem } from 'polished'
import React, { ComponentProps, MouseEventHandler, useCallback } from 'react'
import styled from 'styled-components'
import _PriceRowLoyaltyPointsContent from './_PriceRowLoyaltyPointsContent'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: ${rem(2)} ${rem(8)};
`

interface Props extends ComponentProps<typeof _PriceRowLoyaltyPointsContent> {
  tier: App.LoyaltyTier
  promo: string
  size: 'S' | 'M'
  onPillClick?: MouseEventHandler<HTMLButtonElement>
}

export const SIZES_BODY_TEXT_VARIANTS: Record<Props['size'], ComponentProps<typeof BodyText>['variant']> = {
  S: 'small',
  M: 'medium',
}

const TIER_BODY_TEXT_COLOURS: Record<App.LoyaltyTier, App.Design.ContentColour> = {
  bronze: 'tier-bronze-dark',
  silver: 'tier-silver-dark',
  gold: 'tier-gold-dark',
  platinum: 'tier-platinum',
}

function PriceRowLoyaltyPointsPromoPill({
  tier,
  size,
  promo,
  earnablePoints,
  statusCredits,
  calculationType,
  onInfoIconClick,
  onPillClick,
}: Props) {
  const handlePillClick = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()
    event.stopPropagation()
    onPillClick?.(event)
  }, [onPillClick])

  return <Container>
    <Clickable onClick={onPillClick ? handlePillClick : undefined}><LoyaltyPill variant="primary" tier={tier}>{promo}</LoyaltyPill></Clickable>
    <BodyText variant={SIZES_BODY_TEXT_VARIANTS[size]} weight="bold" colour={TIER_BODY_TEXT_COLOURS[tier]}>
      <_PriceRowLoyaltyPointsContent
        earnablePoints={earnablePoints}
        statusCredits={statusCredits}
        onInfoIconClick={onInfoIconClick}
        calculationType={calculationType}
      />
    </BodyText>
  </Container>
}

export default PriceRowLoyaltyPointsPromoPill
